

export const DEFAULT_USER_PROFILE = {
    DEFAULT_EMPLOYER_PROFILE_PICTURE: "https://storage.googleapis.com/public-platform-assets/default/profile-picture-e.jpg",
    DEFAULT_FREELANCER_PROFILE_PICTURE_MALE: "https://storage.googleapis.com/public-platform-assets/default/profile-picture-f-male.jpg",
    DEFAULT_FREELANCER_PROFILE_PICTURE_FEMALE: "https://storage.googleapis.com/public-platform-assets/default/profile-picture-f-female.jpg",
    DEFAULT_EMPLOYER_TITLE_PICTURE: "https://storage.googleapis.com/public-platform-assets/default/profile-title-picture-e.png",
    DEFAULT_FREELANCER_TITLE_PICTURE: "https://storage.googleapis.com/public-platform-assets/default/profile-title-picture-f.png",
}

export const AI_AGENT_ASSETS = {
    ARIELLE_AVATAR: "https://storage.googleapis.com/public-platform-assets/default/arielle.png",
    ARIELLE_NOBG_AVATAR: "https://storage.googleapis.com/public-platform-assets/default/arielle-nobg.png",
    ARIELLE_HALF_BODY_AVATAR: "https://storage.googleapis.com/public-platform-assets/default/arielle_half_body.png",
}

export const BRAND_ASSETS = {
    FAVICON: "https://storage.googleapis.com/public-platform-assets/brand/favicon.svg",
    LOGO_SMALL_BLACK: "https://storage.googleapis.com/public-platform-assets/brand/icon_black.png",
    LOGO: "https://storage.googleapis.com/public-platform-assets/brand/logo.svg",
}

export const EMPTY_STATE_ASSETS = {
    NO_DATA: "https://storage.googleapis.com/public-platform-assets/default/no-data.svg",
}